export default class instagramWallAction {
    constructor() {
        instagramWallAction.socialWall()
    }
    static socialWall() {
        const $socialWall = $('[data-id="social-wall"]')
        if ($socialWall.length > 0 && !$socialWall.is(':hidden')) {
            import(
                '@wordpress/api-fetch' /* webpackChunkName: "scripts/wordpress_api_fetch" */
            ).then(({ default: apiFetch }) => {
                import('@wordpress/i18n' /* webpackChunkName: "scripts/wordpress_i18n" */).then(
                    ({ __ }) => {
                        apiFetch({
                            path: IRISCollectionCustomer.irisSsoInstagramPath,
                            method: 'POST',
                            data: { limit: 4 },
                        })
                            .then((result) => {
                                $socialWall.html(result.render)
                                import(
                                    '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                                ).then(({ HcLazyload }) => {
                                    HcLazyload.update()
                                })
                            })
                            .catch((e) => {
                                console.log(e)
                                $socialWall.html(IRISCollectionCustomer.irisSsoInstagramError)
                            })
                    },
                )
            })
        }
    }
}

new instagramWallAction()
